"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearSessionKey = exports.getSessionKey = exports.setSessionKey = void 0;
var luxon_1 = require("luxon");
var browser_1 = require("./browser");
var setSessionKey = function (_a) {
    var name = _a.name, value = _a.value, expireAt = _a.expireAt;
    if (!(0, browser_1.isBrowser)()) {
        throw new Error('Cannot set session key on server');
    }
    var payload = __assign({ value: value }, (expireAt && { expireAt: expireAt.toISO() }));
    window.sessionStorage.setItem(name, JSON.stringify(payload));
};
exports.setSessionKey = setSessionKey;
var getSessionKey = function (name) {
    if (!(0, browser_1.isBrowser)())
        return null;
    var item = window.sessionStorage.getItem(name);
    if (!item)
        return null;
    var payload = JSON.parse(item);
    if (!payload.expireAt ||
        luxon_1.DateTime.fromISO(payload.expireAt) > luxon_1.DateTime.local())
        return payload.value;
    return null;
};
exports.getSessionKey = getSessionKey;
var clearSessionKey = function (name) {
    if (!(0, browser_1.isBrowser)()) {
        throw new Error('Cannot clear session key on server');
    }
    window.sessionStorage.removeItem(name);
};
exports.clearSessionKey = clearSessionKey;
//# sourceMappingURL=session.js.map